import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui';
import { PageHeader } from '@/components/layout/PageHeader';
import { routePaths } from '@/app/routes';
import { usePatients } from '../hooks/usePatients';
import { AddPatientForm } from '../components/AddPatientForm';

/**
 * "Adaugă pacient" — one form, two wordings:
 *   - the FIRST patient of a fresh account: nothing in the app works until it
 *     exists, so the shell (AppLayout) sends the user straight here and keeps
 *     the menu inert; the heading says so instead of talking about family;
 *   - a dependent attached to an account that already has a patient.
 * The form itself picks register vs attach from the cached list.
 */
export function AddPatientPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const patients = usePatients();

  // Decided once, on entry: after a successful first add the list refetches
  // with the new patient while the success message is still on screen, and
  // the heading must not flip to the "family member" wording meanwhile.
  const [firstPatient] = useState(() => patients.isSuccess && patients.data.length === 0);

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-5">
      <PageHeader
        title={t(firstPatient ? 'patients.add.first_title' : 'patients.add.title')}
        subtitle={t(firstPatient ? 'patients.add.first_subtitle' : 'patients.add.subtitle')}
      />
      <Card className="p-6 sm:p-7">
        <AddPatientForm
          onSuccess={() => {
            // Give the user a moment to read the success message, then return
            // home. By now the patient list has been refetched (useAddPatient
            // awaits it), so the shell no longer redirects back here.
            setTimeout(() => navigate(routePaths.home), 1200);
          }}
        />
      </Card>
    </div>
  );
}
